<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br/>
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            {{ userStore.user.ssn }}
            <br />
            <br />
            {{ creditBureau.address_name }}
            <br />
            {{ creditBureau.street_address }}
            <br />
            {{ creditBureau.city }}, {{ creditBureau.state_abbrev }} {{ creditBureau.zipcode }}
            <br>
            <br>
            Date: {{ date }}
        </p>
        <p class="letter-content">
            I have been having a hard time extending new credit for myself. I recently reviewed
            my credit report and noticed there are several inaccurate items on my report. I
            understand that the information reported on my credit report must follow an industry
            standard format called Metro 2 and my information must be reported with maximum
            possible accuracy. However upon review of my credit report I have found out that the
            following accounts are reporting inaccurately and they are not metro 2 compliant.
        </p>
        <p>
            <template v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
                <strong id='reason'>This account is reporting inaccurately and it is not metro 2 compliant.</strong><br />
                <strong>NAME OF ACCOUNT:</strong>
                {{ creditor.furnisher_name }}
                <br />
                <template v-if="creditor.reference_number">
                    <strong>REFERENCE NUMBER: </strong>{{ creditor.reference_number }}
                    <br />
                </template>
                <template v-else>
                    <strong>ACCOUNT NUMBER: </strong>{{ creditor.account_number }}
                    <br />
                </template>
                <strong id='instruction'>
                    Verify this account is reporting 100% Accurate and Without Error, and if it's not, Immediately Delete This Account from my credit file.
                </strong>
                <br />
                <br />
            </template>
        </p>
        <p style="padding: 2rem 0rem;" class="letter-content">
            As proof of identity, I have enclosed a copy of my driver’s license and proof of
            address. Once your investigation is completed and you deleted this information
            please mail me a complete and updated copy of my credit report to
            <strong>{{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}</strong>.
        </p>
        <p style="page-break-after: always;">
            Thank you for your time, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }} <br />
            {{ userStore.user.ssn }}
        </p>
    </div>
    <h1 style="margin: 5rem 5rem;">Personal Information</h1>
    <div class="row">
        <p>
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore()
            };
        }
    };
</script>